import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Patient } from 'app/core/interfaces/patient';
import { PatientService } from 'app/core/http/services/patient.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';

type OrganizationPatient = Patient & { last_appointment?: string };

@Component({
  selector: 'page-organization-patient-edit',
  templateUrl: './patient-edit.component.html',
})
export class OrganizationPatientEditComponent extends BaseComponent implements OnInit {
  public name = new FormControl('', [Validators.required, Validators.maxLength(200)]);
  public saving = false;

  public get patient(): OrganizationPatient {
    return this.data.param.patient;
  }

  constructor(
    private injector: Injector,
    private patientService: PatientService,
    private dialogRef: MatDialogRef<OrganizationPatientEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.name.setValue(this.patient.name);
  }

  save(): void {
    if (this.name.invalid) {
      this.name.markAsTouched();
      return;
    }

    const patient: Patient = this.data.param.patient;
    const organizationId = this.auth.currentUserValue.user.id;
    this.saving = true;
    this.patientService.updateNameByOrganization(patient.patient_id, organizationId, this.name.value!.trim()).subscribe({
      next: (updatedPatient) => {
        this.openSnackBar('Nome do paciente atualizado com sucesso.', 'success');
        this.dialogRef.close(updatedPatient);
      },
      error: (error) => {
        this.saving = false;
        const message =
          error?.status === 403
            ? 'Você não tem permissão para atualizar este paciente.'
            : error?.status === 404
              ? 'Este paciente não possui atendimento nesta organização.'
              : 'Não foi possível atualizar o nome do paciente. Tente novamente.';
        this.openSnackBar(message, 'error');
      },
    });
  }
}
